<template>
  <v-container id="docForm" class="max-width">
    <div v-show="sellOnline == 'Y'">
      <!-- first card -->

      <v-card>
        <v-toolbar dense flat color="secondary">
          <v-toolbar-title>POS - Create Sale Delivery</v-toolbar-title>
          <v-btn text color="primary" :to="`/pos/daily/sales`">All Invoices</v-btn>
          <!-- <v-btn text color="accent" to="/on-hold">Orders On Hold</v-btn> -->
          <v-spacer></v-spacer>
          <v-switch class="mt-6" color="orange darken-3" v-model="printing" :label="`Print Receipt`"></v-switch>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-row>
                <v-col cols="12" md="8">
                  <span style="font-size: 16px; font-weight: bold">Bill Details</span>
                  <v-autocomplete class="mt-2" autocomplete="off" dense outlined v-model="record.CardCode"
                    :items="customers" label="Customer" item-text="Name" item-value="id"
                    :search-input.sync="searchCustomers" @change="getBranches(record.CardCode)">

                    <template v-slot:no-data>
                      <v-row align="center" justify="center">
                        <v-btn class="ma-2" color="accent" dark small elevation="0" @click="openCreateCustomer()">
                          <v-icon left>mdi-plus</v-icon>Create A Customer
                        </v-btn>
                      </v-row>
                    </template></v-autocomplete>

                  <v-autocomplete v-show="IsDistributor == 'Y'" class="mt-1" autocomplete="off" dense outlined
                    @change="getSaleEmployee(record.StoreId)" v-model="record.StoreId" :items="branches" label="Branch"
                    item-text="Name" item-value="id"></v-autocomplete><br>

                  <span v-show="IsDistributor == 'Y'" class="style-16" style="color: blue">Sales Rep: {{ saleEmployee &&
                    saleEmployee.name
                  }}</span>

                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="6">
              <v-row class="justify-end">
                <v-col cols="12" md="7">
                  <span style="font-weight: bold; font-size: 18px; float: right">Invoice#: {{ DocNum }}</span>
                  <br />
                  <v-text-field style="margin-bottom: 4px" autocomplete="off" type="text" v-model="ref2" outlined dense
                    label="LPO Ref No"></v-text-field>
                  <DatePicker v-if="canBackDate == 'Y'" @date="setDate" :myDate="date" :title="`Date`" ref="dateRef">
                  </DatePicker>
                  <span v-else class="style-16">Date: {{ date }}</span>
                  <v-text-field class="mt-2" autocomplete="off" type="text" v-model="discount" outlined dense
                    label="Discount %"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- end of first card -->

      <!-- no bp card -->
      <v-card class="mt-4">
        <v-card-text>
          <v-row dense id="po">

            <v-col cols="12">
              <v-data-table :item-class="getRowClass" light dense :items-per-page="pageItems"
                :headers="ImeiScanningVersion == 'Y' ? imeiHeaders : posHeaders" :items="orderItems" item-key="LineNum"
                hide-default-footer disable-sort>
                <template v-slot:item.ItemCode="{ item }">
                  <div style="font-weight: bold; font-size: 14px;">{{ item.ItemCode }}</div>
                </template>

                <template v-slot:item.Name="{ item }">
                  <div style="font-weight: bold; margin-left: 20px; font-size: 14px; width: 400px;">{{ item.Name }}
                  </div>
                </template>

                <template v-slot:item.discount>
                  <div style="font-weight: bold; margin-left: 10px;  font-size: 14px; width: 45px;">{{ discount }} %
                  </div>
                </template>


                <template v-slot:item.imei="{ item }">
                  <v-text-field style="width: 200px" class="orderInput" single-line outlined dense
                    v-model="item.imei"></v-text-field>
                </template>

                <template v-slot:item.available="{ item }">
                  <div style="margin-right: ">{{ item.available }}</div>
                </template>


                <template v-slot:item.Quantity="{ item }">
                  <v-text-field autocomplete="off" type="number" class="orderInput" @input="inputChanged(item)"
                    single-line outlined dense v-model="item.Quantity"></v-text-field>
                </template>

                <template v-slot:item.DiscSum="{ item }">
                  <v-text-field autocomplete="off" type="number" class="orderInput" @input="inputChanged(item)"
                    single-line outlined dense v-model="item.DiscSum"></v-text-field>
                </template>

                <template v-slot:item.Price="{ item }">
                  <v-text-field autocomplete="off" type="number" class="orderInput" @input="inputChanged(item)"
                    single-line outlined dense v-model="item.Price"></v-text-field>
                </template>

                <template v-slot:item.Margin="{ item }">
                  <span style="color: red; margin: 5px">
                    {{
                      parseInt(
                        ((item.Price - item.BuyingPrice) / item.BuyingPrice) * 100
                      )
                    }}
                    %
                  </span>
                </template>

                <template v-slot:item.TaxId="{ item }">
                  <v-autocomplete autocomplete="off" dense outlined single-line v-model="item.TaxId" :items="taxGroups"
                    label="Tax" item-text="Name" item-value="id" @change="inputChanged(item)"></v-autocomplete>
                </template>

                <template v-slot:item.o_p_l_n_s_id="{ item }">
                  <v-autocomplete autocomplete="off" dense outlined single-line v-model="item.o_p_l_n_s_id"
                    :items="item.priceLists" label="Price List" item-text="pricelist.Name" item-value="pricelist.id"
                    @change="oplnChange(item)"></v-autocomplete>
                </template>

                <template v-slot:item.BuyingPrice="{ item }">
                  <v-text-field filled outlined readonly dense v-model="item.BuyingPrice"></v-text-field>
                </template>

                <template v-slot:item.UomEntry="{ item }">
                  <div v-if="item.ManualStatus == 'Y'"
                    style="padding-left: 10px; padding-right: 10px; font-weight: bold">Pcs</div>

                  <v-autocomplete v-else dense autocomplete="off" outlined single-line v-model="item.UomEntry"
                    :items="item.ugp1" label="UOM" item-text="UomName" item-value="UomId"
                    @change="uomChange(item, item.ugp1)"></v-autocomplete>
                </template>

                <!-- <template v-slot:item.LineTotal="{ item }">
                  <v-text-field class="orderInput" single-line outlined dense v-model="item.LineTotal"
                    @input="totalChanged(item)"></v-text-field>
                </template> -->

                <template v-slot:item.LineTotal="{ item }">
                  <div style="font-weight: bold; font-size: 14px; width: 100px">{{ (item.LineTotal - (discount / 100 *
                    item.LineTotal)) | currency }}</div>
                </template>


                <!-- action template -->
                <template v-slot:item.action="{ item }">
                  <v-btn @click="deleteRow(item)" color="red" icon>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <!-- end -->
              </v-data-table>

              <!-- <v-btn @click="addRow" small color="primary" class="mt-1">
              <v-icon left>mdi-plus</v-icon>Add Row
              </v-btn>-->
              <v-autocomplete :filter="customFilter" style="width: 500px" autocomplete="off" v-model="select"
                :isloading="isLoading" :items="products" :search-input.sync="searchProducts"
                @change="setOrderItem(select)" :item-text="smsRef == 'pharmacy' ? 'full_name' : 'Name'" item-value="id"
                cache-items class="mt-2" flat hide-no-data hide-details label="Search Product" outlined dense>
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title>{{ smsRef == 'pharmacy' ? data.item.full_name : data.item.Name
                    }}</v-list-item-title>
                    <v-list-item-subtitle v-show="ShowAvailableStock == 'Y'"
                      :v-html="`Available Qty: ${data.item.AvailableQty}`">Available Qty: {{
                        data.item.AvailableQty }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <!-- outsourced row -->
          <v-row class="subtitle-2 text--primary" style="margin-top: -30px">
            <v-col cols="12">
              <v-btn style="margin-top: -30px" text color="accent" class="float-right" @click="outModal">
                <v-icon>mdi-plus</v-icon>Add Outsourced Item
              </v-btn>

              <v-btn style="margin-top: -30px" text color="accent" class="float-right"
                @click.native="productDialog = true" v-show="IMEI == 'Y'">
                <v-icon>mdi-plus</v-icon>Create New Product
              </v-btn>

              <v-btn v-show="SlgPrcFixed == 'Y'" style="margin-top: -30px" text color="accent" class="float-right"
                @click.native="bpDialog = true">
                <v-icon>mdi-magnify</v-icon>Check BP
              </v-btn>
            </v-col>

            <v-col cols="12" style="margin-top: -20px" v-if="outArray.length > 0">
              <span>Outsourced Items List</span>
              <v-data-table light dense :items-per-page="pageItems" :headers="outHeaders" :items="outArray"
                item-key="LineNum" hide-default-footer disable-sort :mobile-breakpoint="0" :calculate-widths="true">
                <template v-slot:item.Quantity="{ item }">
                  <span style="margin-right: 15px !important">
                    {{
                      item.Quantity
                    }}
                  </span>
                </template>

                <template v-slot:item.Price="{ item }">
                  <span style="margin-right: 15px !important">
                    {{
                      item.Price.toLocaleString()
                    }}
                  </span>
                </template>

                <template v-slot:item.DisplayTotal="{ item }">
                  <span>{{ item.DisplayTotal.toLocaleString() }}</span>
                </template>

                <!-- action template -->
                <template v-slot:item.action="{ item }">
                  <v-btn @click="deleteOutRow(item)" color="red" icon>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <!-- end -->
              </v-data-table>
            </v-col>
          </v-row>
          <!-- end of outsourced row -->
        </v-card-text>
      </v-card>
      <!-- end of card -->

      <!-- third card -->
      <v-row class="mt-2">
        <v-col cols="6">
          <v-card>
            <v-card-text>
              <v-row class="mb-1 subtitle-2 text--primary">
                <div>
                  <span style="font-size: 1.2em; font-weight: 600; padding-left: 20px">Payments</span>
                </div>
                <v-col cols="12" style="padding: 20px; font-size: 20px">
                  <v-data-table dense class="p-4" light :headers="paymentHeaders" :items="accounts" hide-default-footer>
                    <template v-slot:item.Name="{ item }">
                      <div style="font-size: 16px; width: 120px">{{ item.Name }}</div>
                    </template>
                    <template v-slot:item.SumApplied="{ item }">
                      <v-text-field type="number" outlined v-model="item.SumApplied"
                        style="width: 150px"></v-text-field>
                    </template>
                    <template v-slot:item.PaymentRemarks="{ item }">
                      <v-text-field outlined v-model="item.PaymentRemarks" style="width: 170px"></v-text-field>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card>
            <v-card-text>
              <v-row dense class="pa-1">
                <v-col cols="6" class="py-2 font-weight-medium" style="font-size: 1.2em;">Bill:</v-col>
                <v-col cols="6" class="py-2 font-weight-medium" style="font-size: 1.2em;">{{ totalAfterDiscDisplay
                }}.00</v-col>

                <v-col cols="6" class="py-2 font-weight-light">
                  <span style="font-weight: 600;">Paid:</span>
                </v-col>
                <v-col cols="6" class="py-2">
                  <span style>{{ mPaid }}.00</span>
                </v-col>

                <v-col cols="6" class="py-2 font-weight-bold" style="font-size: 1.4em;">Balance:</v-col>
                <v-col cols="6" class="py-2 font-weight-bold" style="font-size: 1.4em;">{{ displayMBalance || 0
                }}.00</v-col>

                <v-col cols="12">
                  <v-autocomplete v-show="SelectSalesPerson == 'Y'" class="mt-2 float-right" autocomplete="off" dense
                    outlined v-model="record.SoldBy" :items="users" label="Sold By" item-text="name" item-value="id">
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>


      </v-row>

      <v-row class="mb-4">
        <v-col cols="12">
          <v-btn color="primary" class="float-right" @click="sendData" :loading="loader">
            <v-icon left>mdi-content-save</v-icon>Create Sale Invoice
          </v-btn>
        </v-col>
      </v-row>
      <!-- end of card -->

      <!-- Customer quick add dialog modal-->
      <v-dialog v-model="customerDialog" max-width="750px">
        <v-card>
          <v-toolbar dense color="primary" dark>
            <v-toolbar-title>Create A Customer</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="customerDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container fluid>
              <customer-editor :initial="customerItem" @data="saveCustomer"></customer-editor>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end of modal-->

      <!-- Outsourced dialog -->
      <v-dialog v-model="outsourcedDialog" max-width="750px">
        <v-card>
          <v-toolbar dense color="secondary" flat>
            <v-toolbar-title>Outsourced Product (sourced from another shop)</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="outsourcedDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container fluid class="subtitle-2 text--primary">
              <v-row>
                <v-col cols="12" xs="12" md="12">
                  <v-text-field autocomplete="off" type="text" v-model="outItem.Name" label="Item Name" outlined
                    dense></v-text-field>
                </v-col>

                <v-col cols="5" xs="5" md="4">
                  <v-text-field autocomplete="off" type="number" v-model="outItem.Quantity"
                    @input="qtyOutChanged(outItem)" label="Qty" outlined dense></v-text-field>
                </v-col>

                <v-col cols="7" xs="7" md="4">
                  <v-text-field autocomplete="off" type="number" v-model="outItem.BuyingPrice"
                    @input="qtyOutChanged(outItem)" label="Buying Price" outlined dense></v-text-field>
                </v-col>

                <v-col cols="7" xs="7" md="4">
                  <v-text-field autocomplete="off" type="number" v-model="outItem.Price" @input="qtyOutChanged(outItem)"
                    label="Selling Price" outlined dense></v-text-field>
                </v-col>

                <v-col cols="12" md="4" xs="12">
                  <span style="font-size: 18px">Total Bill: {{ outItem.DisplayTotal }}</span>
                </v-col>

                <v-col cols="12" md="4" xs="12">
                  <span style="font-size: 18px">Total Profit: {{ outsourcedProfit }}</span>
                </v-col>

                <v-col cols="12">
                  <v-btn color="primary" @click="addOutProduct" :loading="loader" class="float-right">
                    <v-icon left>mdi-plus</v-icon>Add To List
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end of outsourced modal-->

      <!-- product quick add dialog -->
      <v-dialog v-model="productDialog" max-width="850px">
        <v-card>
          <v-toolbar dense color="primary" dark>
            <v-toolbar-title>Create A Product</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="productDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row justify="center">
                <v-col cols="8">
                  <v-row class="mt-10">
                    <v-col cols="12" xs="12" sm="12" md="12">
                      <v-text-field autocomplete="off" type="text" hide-details outlined dense label="Product Name"
                        v-model="productRecord.Name"></v-text-field>
                    </v-col>

                    <v-col cols="12" xs="12" sm="12" md="6">
                      <v-text-field autocomplete="off" type="text" hide-details outlined dense label="Buying Price"
                        v-model="productRecord.BuyingPrice"></v-text-field>
                    </v-col>

                    <v-col cols="12" xs="12" sm="12" md="6">
                      <v-text-field autocomplete="off" type="text" hide-details outlined dense label="Selling Price"
                        v-model="productRecord.SellingPrice"></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-btn v-if="docCreate == true" color="accent" @click="saveProduct" :loading="loader">
                        <v-icon left>mdi-content-save</v-icon>Save Product
                      </v-btn>
                    </v-col>

                    <!-- <v-col cols="3">
          <v-text-field dense outlined v-model="record.BuyingPrice" label="Buying Price(custom)"></v-text-field>
                    </v-col>-->
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end of modal-->

      <!-- product quick add dialog -->
      <v-dialog v-model="bpDialog" max-width="850px">
        <v-card>
          <v-toolbar dense color="primary" dark>
            <v-toolbar-title>Check Buying Price</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="bpDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-row justify="center">
                <v-col cols="8">
                  <v-text-field outlined dense v-model="bpText" @input="querySelectionsBp"></v-text-field>
                </v-col>

                <v-col cols="8" v-show="bpText != ''">
                  <v-data-table light dense :items-per-page="2000" :headers="pricesHeaders" :items="bpProducts"
                    item-key="id" hide-default-footer disable-sort :mobile-breakpoint="0" :calculate-widths="true">
                    <template v-slot:item.BuyingPrice="{ item }">
                      <span style="margin-right: 15px !important">
                        {{
                          item.BuyingPrice && item.BuyingPrice.toLocaleString()
                        }}
                      </span>
                    </template>

                    <template v-slot:item.SellingPrice="{ item }">
                      <span>{{ item.SellingPrice && item.SellingPrice.toLocaleString() }}</span>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end of modal-->

      <!-- snackbar -->
      <snackbar ref="snackbar"></snackbar>
    </div>

    <div v-show="sellOnline == 'N'">
      <span class="style-18-accent">Selling online not enabled for this account, please sell using the offline version
        for
        receipt numbers to be consistent.</span>
    </div>
  </v-container>
</template>

<script>
//import AccountEditor from "@/components/subscriber/accounts/_components/quick-editor.vue";
// import ProductEditor from "@/components/subscriber/products/creation/_components/basic-editor.vue";
import CustomerEditor from "@/components/subscriber/customers/_components/quick-editor.vue";
// import customWalkinVue from "../editing/sales/_components/custom-walkin.vue";
import { v4 as uuidv4 } from 'uuid';
export default {
  name: "PosPortal",
  components: {
    // AccountEditor,
    CustomerEditor
    // ProductEditor
  },
  props: {
    docCreate: {
      type: Boolean
    },
    loaderOff: {
      type: Boolean
    },
    copyStatus: {
      type: Boolean
    }
  },
  data: () => ({
    uuid: uuidv4(),
    IsDistributor: "",
    ImeiScanningVersion: "N",
    record: {},
    DefaultWarehouse: 0,
    discount: 0,
    sellOnline: "Y",
    productRecord: {},
    saleEmployee: {},
    productDialog: false,
    bpDialog: false,
    productItem: {},
    bpProducts: [],
    printing: true,
    bpSetting: "",
    SelectSalesPerson: false,
    customerDialog: false,
    outsourcedDialog: false,
    currentCustomerBalance: null,
    select: "",
    selectDesc: "",
    searchProducts: null,
    searchCustomers: null,
    isLoading: false,
    outItem: {},
    accountItem: {},
    customerItem: {},
    bpText: "",
    accountDialog: false,
    enableCreate: true,
    searchingProduct: false,
    UserSign: null,
    enablePriceList: "N",
    showStockHint: true,
    ref2: null,
    IMEI: null,
    SlgPrcFixed: null,
    SoldBy: null,
    loader: false,
    pageItems: 100,
    DiscOnTotal: null,
    AmountGiven: null,
    multiplePayment: "Y",
    ShowAvailableStock: "",
    selectedProduct: null,
    SumApplied: null,
    DocNum: null,
    selectedItems: [],
    branches: [],
    activeRow: null,
    storeId: null,
    singleSelect: true,
    paymentItem: {},
    paymentDialog: false,
    payments: [],
    orderItems: [],
    customers: [],
    products: [],
    accounts: [],
    taxGroups: [],
    stores: [],
    users: [],
    outArray: [],
    drivers: [],
    date: new Date().toISOString().substr(0, 10),
    smsRef: "",
    clearDate: "",
    dateReadonly: "N",
    AccountVersion: "N",
    posHeadersCopy: [
      { text: "Product", value: "Name" },
      { text: "Qty To Sell", value: "Quantity" },
      { text: "Selling Price", value: "Price" },
      { text: "Total", value: "LineTotal" },
      { text: "Action", value: "action" }
    ],
    posHeaders: [
      { text: "Code", value: "ItemCode" },
      { text: "Product", value: "Name" },
      { text: "Qty To Sell", value: "Quantity" },
      { text: "Unit", value: "UomEntry" },
      { text: "Price", value: "Price" },
      { text: "Disc.", value: "discount" },
      // { text: "Tax", value: "TaxId" },
      { text: "Total", value: "LineTotal" },
      // { text: "Ref No", value: "ref1" },
      // { text: "p. Margin", value: "Margin" },
      { text: "Action", value: "action" }
    ],
    imeiHeaders: [
      { text: "Product", value: "Name" },
      { text: "Qty To Sell", value: "Quantity" },
      { text: "Price", value: "Price" },
      { text: "Total", value: "LineTotal" },
      { text: "IMEI", value: "imei" },
      { text: "Action", value: "action" }
    ],
    uomHeaders: [
      { text: "Product", value: "Name" },
      { text: "Available", value: "available" },
      { text: "Qty To Sell", value: "Quantity" },
      { text: "Sales Unit", value: "UomEntry" },
      { text: "Selling Price", value: "Price" },
      { text: "Discount", value: "DiscSum" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Action", value: "action" }
    ],
    pricesHeaders: [
      { text: "Product", value: "Name" },
      { text: "Buying Price", value: "BuyingPrice" },
      { text: "Selling Price", value: "SellingPrice" }
    ],
    outHeaders: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Buying Price", value: "BuyingPrice" },
      { text: "Selling Price", value: "Price" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Profit", value: "LineProfit" },
      { text: "Action", value: "action" }
    ],
    paymentHeaders: [
      { text: "Account", value: "Name" },
      { text: "Amount", value: "SumApplied" }
      // { text: "Ref/Code", value: "PaymentRemarks" },
    ]
  }),
  computed: {
    canBackDate() {
      return localStorage.getItem("canBackDate");
    },
    role() {
      return localStorage.getItem("userRole");
    },
    userName() {
      return localStorage.getItem("userName");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    storeName() {
      return localStorage.getItem("storeName");
    },
    totalAmount() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map(item => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    mTotalPayments() {
      let total = 0;
      if (typeof this.accounts != "undefined" && this.accounts.length > 0) {
        return this.accounts
          .map(item => {
            let amount = 0;
            if (item.SumApplied) {
              amount = parseFloat(item.SumApplied);
            }

            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    mPaid() {
      return this.mTotalPayments.toLocaleString();
    },
    changeCash() {
      let change = 0;
      let changeAmount = this.mTotalPayments - this.totalAfterDisc;
      change = changeAmount;
      return change;
    },
    mBalance() {
      let bill = 0;
      let paid = 0;
      bill = this.totalAfterDisc;
      paid = this.mTotalPayments;
      const balance = bill - paid;
      return balance;
    },
    displayMBalance() {
      return this.mBalance.toLocaleString();
    },
    balance() {
      let sum = 0;
      if (this.SumApplied) {
        sum = this.SumApplied;
      }
      let disc = 0;
      if (this.DiscOnTotal) {
        disc = this.DiscOnTotal;
      }
      const balance = this.totalAmount - parseFloat(sum) - parseFloat(disc);
      return balance;
    },
    totalAfterDisc() {
      let discPerc = 0;

      if (this.discount != null && this.discount != undefined && this.discount != "") {
        discPerc = this.discount;
      }

      let subTotal = this.totalAmount + this.outTotalAmount;
      let discount = parseFloat(discPerc) / 100 * subTotal;
      const total = this.totalAmount + this.outTotalAmount - parseFloat(discount);
      return total;
    },
    totalAfterDiscDisplay() {
      return this.totalAfterDisc.toLocaleString();
    },
    displayBalance() {
      return this.balance.toLocaleString();
    },
    totalDisplayAmount() {
      return this.totalAmount.toLocaleString();
    },
    outsourcedProfit() {
      let qty = 0;
      let buyingPrice = 0;
      let sellingPrice = 0;
      let profit = 0;

      qty = this.outItem.Quantity;
      buyingPrice = this.outItem.BuyingPrice;
      sellingPrice = this.outItem.Price;

      profit = qty * sellingPrice - qty * buyingPrice;

      return profit;
    },
    outTotalAmount() {
      let total = 0;
      if (typeof this.outArray != "undefined" && this.outArray.length > 0) {
        return this.outArray
          .map(item => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    }
  },
  watch: {
    stores: {
      handler: "setDriver",
      immediate: true
    },
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    },
    searchCustomers(val) {
      if (val && val !== this.select && this.queryCustomers(val)) {
        this.queryCustomers(val);
      }
    }
  },
  methods: {
    customFilter(item, queryText, itemText) {
      const words = queryText.toLowerCase().split(/\s+/)
      const text = itemText.toLowerCase()
      return words.every(word => text.includes(word))
    },
    getRowClass(item) {
      return item.selected ? 'selected-row' : '';
    },
    saveProduct(data) {
      const url = "/products";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.productDialog = false;
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show("Product added Successfully", "green");
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(res => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(res.ResultDesc, "red");
        });
    },
    querySelectionsBp() {
      const searchText = this.bpText;

      const self = this;

      const url = "/search-products-bp";
      const data = {
        searchText: searchText
      };
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.bpProducts = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
      // }
    },
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";

      var customerId = 0;

      const data = {
        SearchText: String(searchText),
        CustomerId: parseInt(customerId)
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            console.log(res.ResponseData, " serach res on pos");
            if (res.ResponseData != null) {
              console.log(res.ResponseData, " serach res on pos");
              self.products = res.ResponseData;
            }
          } else {
            self.$store.commit("btnLoader", false);
            // this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(() => {
          self.$store.commit("btnLoader", false);
          // this.$refs.snackbar.show(err, "red");
        });
    },
    queryCustomers(searchText) {
      const self = this;
      const url = "/customers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            // if array length > 1
            self.customers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDriver(val) {
      if (val) {
        const store_id = this.activeStore;
        const selectedStore = val.find(record => {
          return record.id === parseInt(store_id);
        });
        if (selectedStore && selectedStore.driver != undefined) {
          this.record.driver = selectedStore.driver.id;
        }
      }
    },
    setNewDriver() {
      const stores = this.stores;
      const store_id = this.activeStore;
      const selectedStore = stores.find(record => {
        return record.id === parseInt(store_id);
      });
      if (selectedStore.driver) {
        this.record.driver = selectedStore.driver.id;
      }
    },
    outModal() {
      this.outItem = {};
      this.outsourcedDialog = true;
    },
    customerModal() {
      this.customerDialog = true;
    },
    saveCustomer(data) {
      var storeId = parseInt(this.activeStore);
      data.store_id = storeId;
      const url = "/customers";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$refs.snackbar.show("Customer Added Successully", "green");
            this.customerItem = {};
            self.customerDialog = false;
            self.$store.commit("btnLoader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("btnLoader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
          self.$store.commit("btnLoader", false);
        });
    },
    openCreate() {
      this.accountDialog = true;
    },
    openCreateCustomer() {
      this.customerDialog = true;
    },
    qtyOutChanged(data) {
      let Price;
      let Quantity;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      const LineTotal = Price * Quantity;

      const DisplayTotal = LineTotal.toLocaleString();
      // find item

      this.outItem.LineTotal = LineTotal;
      this.outItem.DisplayTotal = DisplayTotal;
    },
    addOutProduct() {
      if (
        this.outItem.Name == undefined ||
        this.outItem.Quantity == undefined ||
        this.outItem.Price == undefined ||
        this.outItem.Price == undefined
      ) {
        this.$refs.snackbar.show("Please fill all the fields!", "red");
      } else {
        const self = this;
        const initArray = [];
        self.outItem.LineNum = `${new Date().getTime()}-${Math.random()}`;
        self.outItem.Commission = this.outsourcedProfit;
        self.outItem.LineProfit = this.outsourcedProfit;
        self.outItem.UomName = "Unit(s)";
        const LineTotal =
          parseFloat(this.outItem.Quantity) * parseFloat(this.outItem.Price);
        self.outItem.LineTotal = LineTotal;
        initArray.push(self.outItem);
        self.outArray = [...self.outArray, ...initArray];
        this.outItem = {};
        this.outsourcedDialog = false;
      }
    },
    deleteOutRow(item) {
      const selectedRow = this.outArray.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.outArray.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.outArray.splice(pos, 1);
    },
    saveAccount(data) {
      const url = "/accounts";
      const self = this;
      this.$store.commit("btnLoader", true);
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = [...this.accounts, res.ResponseData];
            self.paymentItem.o_a_c_t_s_id = res.ResponseData.id;
            self.$refs.snackbar.show("Account Added Successully", "green");
            self.$store.commit("btnLoader", false);
            self.accountDialog = false;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    addPayment() {
      const accoutId = this.paymentItem.o_a_c_t_s_id;
      if (accoutId == undefined) {
        this.$refs.snackbar.show("Please select payment mode!", "red");
      } else {
        if (this.paymentItem.SumApplied == undefined) {
          this.$refs.snackbar.show("Please enter amount paid!", "red");
        } else {
          const item = this.paymentItem;
          const account = this.accounts.find(record => {
            return record.id === accoutId;
          });
          // check if payment mode exist
          const data = {
            o_a_c_t_s_id: account.id,
            account: account.Name,
            SumApplied: item.SumApplied,
            PaymentRemarks: item.PaymentRemarks,
            PaymentPhone: item.PaymentPhone
          };
          this.payments.push(data);
          this.paymentItem = {};
          this.paymentDialog = false;

          // end of check
        }
      }
    },
    deleteAccount(item) {
      const selectedRow = this.payments.find(record => {
        return record.o_a_c_t_s_id === item.o_a_c_t_s_id;
      });
      const pos = this.payments.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.payments.splice(pos, 1);
    },
    setDate(date) {
      this.date = date;
    },
    deleteRow(item) {
      const selectedRow = this.orderItems.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.orderItems.splice(pos, 1);
      this.activeRow = null;
      this.selectedItems = [];
    },
    selectedRow($event) {
      this.activeRow = $event.item.o_i_t_m_s_id;
    },
    totalChanged(data) {
      let Quantity;
      let LineTotal;

      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      if (data.LineTotal) {
        LineTotal = parseFloat(data.LineTotal);
      } else {
        LineTotal = 0;
      }

      const currentItem = this.orderItems.find(record => {
        return record.LineNum === data.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }

      const correctPrice = LineTotal / Quantity;
      currentItem.Price = correctPrice;
      this.orderItems[pos] = currentItem;
    },
    inputChanged(data) {
      if (data.Quantity > data.available) {
        this.$refs.snackbar.show(
          `Your stock is low! current stock ${data.available}`,
          "red"
        );
      }

      let Price;
      let Quantity;
      let DiscSum;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      if (data.DiscSum) {
        DiscSum = parseFloat(data.DiscSum);
      } else {
        DiscSum = 0;
      }
      const TotalBefTax = Price * Quantity;
      // add tax
      const tax = this.taxGroups.find(record => {
        return record.id === data.TaxId;
      });
      let taxAmount = 0;
      let taxRate = 0;
      if (tax) {
        taxRate = tax.Rate;
        taxAmount = (taxRate / 100) * TotalBefTax;
      }
      const TotalAfterTax = TotalBefTax + taxAmount;
      const LineTotal = TotalAfterTax - DiscSum;
      const DisplayTotal = LineTotal.toLocaleString();
      // find item
      const currentItem = this.orderItems.find(record => {
        return record.LineNum === data.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      // end of find
      // update record
      currentItem.TaxRate = taxRate;
      currentItem.TaxAmount = taxAmount;
      currentItem.LineTotal = LineTotal;
      currentItem.DisplayTotal = DisplayTotal;
      this.orderItems[pos] = currentItem;
      // }
    },
    oplnChange(item) {
      const currentItem = this.orderItems.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      const qData = {
        product_id: item.o_i_t_m_s_id,
        SUoMEntry: item.UomEntry,
        o_p_l_n_s_id: item.o_p_l_n_s_id
      };
      const url = "/price-calculation";
      const self = this;
      self.$store.dispatch("post", { url, data: qData }).then(res => {
        currentItem.Price = res.ResponseData.FINALSALESPRICE;
        self.orderItems[pos] = currentItem;
        self.inputChanged(currentItem);
      });
    },
    uomChange(item, ugp1) {
      const currentItem = this.orderItems.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }

      const ugp1Record = ugp1.find(record => {
        return record.UomEntry === item.UomEntry;
      });

      currentItem.Price = ugp1Record.SellingPrice;
      currentItem.BuyingPrice = ugp1Record.BuyingPrice;
      this.orderItems[pos] = currentItem;
      this.inputChanged(currentItem);
    },
    setOrderItem(id) {
      const self = this;
      var storeId = this.activeStore;

      if (this.IsDistributor == 'Y') {
        storeId = this.DefaultWarehouse;
      }

      var url = `/product-inventory/${id}/${storeId}`;

      // fetch the product from database
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            const product = res.ResponseData;
            let currentItem = {};
            const LineNum = new Date().getTime();
            currentItem.refNo = "";
            currentItem.LineNum = LineNum;
            currentItem.Quantity = null;
            currentItem.ManualStatus = product.HasUom == 0 ? "Y" : "N";
            currentItem.o_i_t_m_s_id = id;
            if (self.IsDistributor == "N") {
              currentItem.ItemCode = "";
            }

            if (self.IsDistributor == "Y") {
              if (product.SupermarketCode == "") {
                currentItem.ItemCode = product.ItemCode;
              }

              if (product.SupermarketCode != "") {
                currentItem.ItemCode = product.SupermarketCode;
              }

            }

            currentItem.ProductName = product.Name;
            currentItem.Name = product.Name;
            currentItem.AvailableQty = product.AvailableQty;
            currentItem.StockBal = product.AvailableQty;
            // end

            let initArray = [];
            if (product.HasUom === 0) {
              // check if manual yes and assign
              var sellingPrice = product.sellingPrice;
              var buyingPrice = product.buyingPrice;
              currentItem.BuyingPrice = buyingPrice;
              currentItem.Price = sellingPrice;
              currentItem.currentPrice = sellingPrice;
              currentItem.uomEntryName = "Pc(s)";
              currentItem.UomEntry = 0;
              currentItem.Quantity = 1;
              const total = 1 * parseFloat(sellingPrice);
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = total.toLocaleString();
              // end of manual yes
            }

            // start of manual No status
            if (product.HasUom === 1) {
              let ugp1Data = product.ugp1;
              const ugp1Record = ugp1Data.find(record => {
                return record.UomEntry === product.SUoMEntry;
              });
              currentItem.ugp1 = product.ugp1;
              currentItem.UomEntry = product.SUoMEntry;
              currentItem.uomEntryName = ugp1Record.UomName;
              currentItem.BuyingPrice = ugp1Record.BuyingPrice;
              currentItem.Price = ugp1Record.SellingPrice;
              currentItem.Quantity = 1;
              currentItem.imei = "";
              const total = 1 * parseFloat(ugp1Record.SellingPrice);
              currentItem.LineTotal = total;
              currentItem.DisplayTotal = total.toLocaleString();
            }

            initArray.push(currentItem);
            this.orderItems = [...this.orderItems, ...initArray];
            this.select = "";
            self.products = [];

            this.select = null;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    // setOrderItem(id) {
    //   const store_id = this.activeStore;
    //   const self = this;

    //   var customerId = this.record.CardCode;

    //   if (customerId == undefined) {
    //     customerId = 0;
    //   }

    //   var data = {
    //     CustomerId: parseInt(customerId),
    //     ProductId: parseInt(id)
    //   };

    //   var selectedProduct = this.products.find(record => {
    //     return record.id === id
    //   });

    //   var ItemCode = selectedProduct.item_code;

    //   var url = `/product-prices`;
    //   this.$store
    //     .dispatch("post", { url, data })
    //     .then(res => {
    //       if (res.ResultCode == 1200) {
    //         const product = res.ResponseData;

    //         // current item definition
    //         let currentItem = {};
    //         currentItem.Quantity = 1;
    //         currentItem.ManualStatus = product.HasUom == 0 ? "Y" : "N";
    //         currentItem.UomEntry = product.SUoMEntry;
    //         currentItem.o_i_t_m_s_id = id;
    //         currentItem.Name = product.Name;
    //         currentItem.store_id = store_id;
    //         const LineNum = new Date().getTime();
    //         currentItem.LineNum = LineNum;
    //         currentItem.DiscSum = null;
    //         currentItem.ItemCode = `${ItemCode}`;
    //         // end

    //         let initArray = [];
    //         if (product.HasUom === 0) {
    //           // check if manual yes and assign
    //           var sellingPrice = product.sellingPrice;
    //           var buyingPrice = product.buyingPrice;
    //           currentItem.BuyingPrice = buyingPrice;
    //           currentItem.Price = sellingPrice;
    //           currentItem.currentPrice = sellingPrice;
    //           const total = 1 * parseFloat(sellingPrice);
    //           currentItem.LineTotal = total;
    //           currentItem.DisplayTotal = total.toLocaleString();

    //           initArray.push(currentItem);
    //           this.orderItems = [...this.orderItems, ...initArray];
    //           this.select = null;
    //           // end of manual yes
    //         }

    //         // start of manual No status
    //         if (product.HasUom === 1) {
    //           let ugp1Data = product.ugp1;
    //           const ugp1Record = ugp1Data.find(record => {
    //             return record.UomEntry === product.SUoMEntry;
    //           });
    //           currentItem.ugp1 = product.ugp1;
    //           currentItem.Price = ugp1Record.SellingPrice;
    //           currentItem.BuyingPrice = ugp1Record.BuyingPrice;
    //           currentItem.currentPrice = ugp1Record.SellingPrice;
    //           const total = 1 * ugp1Record.SellingPrice;
    //           currentItem.LineTotal = total;
    //           currentItem.DisplayTotal = total.toLocaleString();

    //           // push to array
    //           initArray.push(currentItem);
    //           this.orderItems = [...this.orderItems, ...initArray];
    //           this.select = "";
    //           self.products = [];
    //           // end of push
    //         }
    //       } else {
    //         this.$refs.snackbar.show(res.msg, "red");
    //       }
    //     })
    //     .catch(err => {
    //       this.$refs.snackbar.show(err, "red");
    //     });
    //   // end of fetch
    // },
    generateUniqueId() {
      var subscriberId = localStorage.getItem("subscriber_id");
      var date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      var dateString = `${year}-${month}-${day}`;
      var uniqueId = `${uuidv4()}-${dateString}-${subscriberId}`;
      return uniqueId;
    },
    checkExpiry() {
      const self = this;
      const userId = this.subscriberId;
      this.$store
        .dispatch("get", `/users/${userId}`)
        .then((res) => {
          console.log(res.ResponseData, "res g");
          if (res.ResponseData.expiryStatus == 1) {
            self.$router.push("/inactive-account");
          }
        })
        .catch(() => { });
    },
    sendData() {
      if (this.date == null || this.date == undefined) {
        this.$refs.snackbar.show("Please select date!", "red");
        return;
      }

      if (this.IsDistributor == "Y") {
        if (this.record.CardCode == undefined || this.record.CardCode == null) {
          this.$refs.snackbar.show("Please select a customer", "red");
          return;
        }
      }

      // if (this.IsDistributor == "Y") {
      //   if (this.record.StoreId == undefined || this.record.StoreId == null) {
      //     this.$refs.snackbar.show("Please select a branch", "red");
      //     return;
      //   }
      // }

      if (this.orderItems.length <= 0 && this.outArray.length <= 0) {
        this.$refs.snackbar.show("You must have at least one product", "red");
        return;
      }

      if (this.SelectSalesPerson == "Y" && this.record.SoldBy == null) {
        this.$refs.snackbar.show("Please select the seller", "red");
        return;
      }


      let balance = 0;
      if (this.multiplePayment == "N") {
        balance = this.totalAfterDisc - this.SumApplied;
      } else {
        balance = this.mBalance;
      }

      if (balance > 0 && this.record.CardCode == undefined) {
        this.$refs.snackbar.show("Please select customer", "red");
        return;
      }

      const userId = parseInt(localStorage.getItem("user_id"));

      var soldBy = userId;

      if (this.SelectSalesPerson == "Y") {
        soldBy = parseInt(this.record.SoldBy);
      }


      var uniqueId = this.generateUniqueId();
      // end of unique id

      let saleDate = this.date;
      this.record = { ...this.record, DocDate: saleDate };
      const data = this.record;
      data.LocalId = uniqueId;
      data.UniqueId = uniqueId;
      data.TargetType = null;
      data.BaseType = 0;
      data.BaseEntry = null;
      data.ObjType = 14;
      data.DocTotal = this.totalAfterDisc;
      data.DocNum = this.DocNum;
      data.UserSign = userId;
      data.SoldBy = soldBy;
      data.ref2 = this.ref2;
      data.LpoNo = this.ref2;
      var storeId = parseInt(this.activeStore);
      data.storeId = storeId;
      data.SalesRepId = 0;
      data.Discount = parseFloat(this.discount);

      if (this.IsDistributor == "Y") {
        data.SalesRepId = parseInt(this.saleEmployee.id);
      }

      data.HeldOrderID = 0;

      // append order rows
      var orderData = this.orderItems;

      var rows = [];
      for (const row of orderData) {
        var subLineTotal = parseFloat(row.LineTotal);
        let discPerc = 0;

        if (this.discount != null && this.discount != undefined && this.discount != "") {
          discPerc = this.discount;
        }

        let discount = parseFloat(discPerc) / 100 * subLineTotal;

        var details = {
          productId: row.o_i_t_m_s_id,
          itemCode: `${row.ItemCode}`,
          UomEntry: row.UomEntry,
          Quantity: parseFloat(row.Quantity),
          BuyingPrice: parseFloat(row.BuyingPrice),
          Price: parseFloat(row.Price),
          Discount: parseFloat(discPerc),
          LineTotal: parseFloat(row.LineTotal) - discount,
          name: row.Name,
          imei: row.imei,
          storeId: storeId
        };

        rows.push(details);
      }
      // end

      var defaultWarehouse = parseInt(this.DefaultWarehouse);

      if (this.IsDistributor == 'Y') {
        data.storeId = defaultWarehouse;
      }

      data.rows = rows;

      // append outsource rows
      var outsourceData = this.outArray;
      var outRows = [];
      for (const row of outsourceData) {
        var outDetails = {
          Name: row.Name,
          Quantity: parseFloat(row.Quantity),
          BuyingPrice: parseFloat(row.BuyingPrice),
          Price: parseFloat(row.Price),
          LineTotal: parseFloat(row.LineTotal),
          LineProfit: parseFloat(row.LineProfit)
        };

        outRows.push(outDetails);
      }

      data.outRows = outRows;

      let Dis = 0;
      if (this.DiscOnTotal == null) {
        Dis = 0;
      } else {
        Dis = this.DiscOnTotal;
      }
      data.DiscSum = Dis;
      data.totalAfterDisc = this.totalAfterDisc;
      if (this.multiplePayment == "N") {
        data.TotalPaid = this.SumApplied;
        data.Balance = this.balance;
      } else {
        data.TotalPaid = this.mTotalPayments;
        data.Balance = this.mBalance;
      }

      let saleType = "";
      if (data.Balance > 0) {
        saleType = "credit";
      } else {
        saleType = "cash";
      }
      data.saleType = saleType;
      data.userName = this.userName;
      // set payments
      const paidAmount = this.SumApplied;
      if (this.multiplePayment == "N") {
        let paymentData = { o_a_c_t_s_id: 1, Amount: parseFloat(paidAmount) };
        this.payments.push(paymentData);
      }

      const accountsData = this.accounts;
      let tenderPayments = [];

      // compute cash amount
      let cashAccountId = null;
      for (const account of accountsData) {
        let cashAccount = this.accounts[0];
        if (cashAccount.Name == account.Name) {
          if (account.SumApplied) {
            cashAccountId = account.id;
          }
        }
      }

      let otherPayments = 0;
      for (const account of accountsData) {
        let cashAccount = this.accounts[0];
        if (cashAccount.Name != account.Name) {
          if (account.SumApplied) {
            otherPayments = +account.SumApplied;
          }
        }
      }

      // if change <=0
      if (this.changeCash <= 0) {
        for (const account of accountsData) {
          if (account.SumApplied) {
            let details = {
              storeId: storeId,
              o_a_c_t_s_id: account.id,
              Amount: parseFloat(account.SumApplied),
              PaymentRemarks: "",
              PaymentPhone: ""
            };
            tenderPayments.push(details);
          }
        }
      }
      // end

      // if change > 0
      if (this.changeCash > 0) {
        for (const account of accountsData) {
          let requiredCash = this.totalAfterDisc - otherPayments;
          // compute other accounts data
          if (cashAccountId != account.id) {
            if (account.SumApplied) {
              let details = {
                storeId: storeId,
                o_a_c_t_s_id: account.id,
                Amount: parseFloat(account.SumApplied),
                PaymentRemarks: "",
                PaymentPhone: ""
              };
              tenderPayments.push(details);
            }
          }
          // end of other accounts data

          // prepare cash account
          if (cashAccountId == account.id) {
            let cashAccountDetails = {
              storeId: storeId,
              o_a_c_t_s_id: cashAccountId,
              Amount: parseFloat(requiredCash),
              PaymentRemarks: "",
              PaymentPhone: ""
            };
            tenderPayments.push(cashAccountDetails);
          }
          // end
        }
      }
      // end

      // prepare payments
      data.payments = tenderPayments;

      // get customer details
      let CardCode = this.record.CardCode;
      const selectedCustomer = this.customers.find(record => {
        return record.id === CardCode;
      });

      let custName = "";
      let custPhone = "";
      let custAddress = "";

      if (selectedCustomer) {
        custName = selectedCustomer.Name;
        custPhone = selectedCustomer.PhoneNumber;
        custAddress = selectedCustomer.Address;
      }

      data.deliveryCustomer = custName;
      data.deliveryPhone = custPhone;
      data.deliveryAddress = custAddress;

      // compute delivery charges
      const deliveryItems = this.orderItems.filter(record => {
        return record.itemType == "C";
      });

      let totalDelivery = 0;
      if (typeof deliveryItems != "undefined" && deliveryItems.length > 0) {
        totalDelivery = deliveryItems
          .map(item => {
            const amount = parseFloat(item.LineTotal);
            totalDelivery = +amount;
            return totalDelivery;
          })
          .reduce((val, a) => {
            return val + a;
          });
      }

      data.totalDelivery = totalDelivery;
      // data.DepositId = 0;
      // end

      // save data
      const url = "/create-document";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.getDocNum();
            const NewDate = this.record.DocDate;
            self.record = {};
            self.record.DocDate = NewDate;
            if (self.clearDate == "Y") {
              this.$refs.dateRef.clearDate();
            }
            self.orderItems = [];
            self.outArray = [];
            self.SumApplied = 0;
            self.payments = [];
            self.DiscOnTotal = 0;
            self.ref2 = null;
            self.UserSign = null;
            this.$refs.snackbar.show("Sale successful", "green");
            self.loader = false;
            self.getAccounts();
            var url = `/sale-preview/${res.ResponseData["invoiceId"]}`;
            self.$router.push(url);
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        }).finally(() => {
          self.loader = false;
        });
      // balance < 0 curly brace
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getBranches(id) {
      const self = this;
      var url = `/stores/customers/${id}`;
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.branches = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getSaleEmployee(id) {
      const self = this;
      var url = `/get-sale-employee/${id}`;
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.saleEmployee = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData) {
              self.storeId = res.ResponseData.DefaultStockStore;
              self.IMEI = res.ResponseData.IMEI;
              self.SoldBy = res.ResponseData.SoldBy;
              self.smsRef = res.ResponseData.smsRef;
              self.bpSetting = res.ResponseData.SlgPrcFixed;
              self.enablePriceList = res.ResponseData.enablePriceList;
              self.clearDate = res.ResponseData.clearDate;
              self.dateReadonly = res.ResponseData.dateReadonly;
              self.SlgPrcFixed = res.ResponseData.SlgPrcFixed;
              self.IsDistributor = res.ResponseData.IsDistributor;
              self.SelectSalesPerson = res.ResponseData.SelectSalesPerson;
              self.ShowAvailableStock = res.ResponseData.ShowAvailableStock;
              self.ImeiScanningVersion = res.ResponseData.ImeiScanningVersion;
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/14`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.DocNum = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    showAccounts() {
      this.getAccounts();
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    addRow() {
      let initArray = [];
      const LineNum = `${new Date().getTime()}-${Math.random()}`;
      const details = {
        LineNum: LineNum,
        Name: null,
        Quantity: 1,
        Price: null,
        LineTotal: 0,
        TaxId: this.taxGroups[0].id,
        TaxRate: null,
        ref1: null,
        TaxAmount: null,
        UomEntry: null,
        ManualStatus: null,
        ugp1: [],
        DiscSum: null,
        DisplayTotal: 0,
        BatchID: null,
        PurchaseCurrency: null,
        cnvRate: null,
        BaseCurrencyTotal: null
      };
      initArray.push(details);
      this.orderItems = [...this.orderItems, ...initArray];
    },
    // setDefaultRow() {
    //   const self = this;
    //   this.$store.dispatch("get", `/taxgroups/O`).then(res => {
    //     if (res.ResultCode == 1200) {
    //       self.taxGroups = res.ResponseData;
    //       const LineNum = new Date().getTime();
    //       let initArray = [];
    //       const details = {
    //         LineNum: LineNum,
    //         Name: null,
    //         Quantity: 1,
    //         Price: null,
    //         LineTotal: 0,
    //         TaxId: res.ResponseData[0].id,
    //         TaxRate: null,
    //         ref1: null,
    //         TaxAmount: null,
    //         UomEntry: null,
    //         ManualStatus: null,
    //         ugp1: [],
    //         DiscSum: null,
    //         DisplayTotal: 0,
    //         BatchID: null,
    //         PurchaseCurrency: null,
    //         cnvRate: null,
    //         BaseCurrencyTotal: null
    //       };
    //       initArray.push(details);
    //       this.orderItems = [...this.orderItems, ...initArray];
    //     }
    //   });
    // },
    getCustomerBalance(id) {
      const self = this;
      this.$store
        .dispatch("get", `/get-customer-balance/${id}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.currentCustomerBalance = res.ResponseData.Balance;
          } else {
            self.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    resetLoader() {
      this.loader = false;
      this.$store.commit("btnLoader", false);
    },
    getGlIntegration() {
      const self = this;
      this.$store
        .dispatch("get", `/gl-integration`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.DefaultWarehouse = res.ResponseData.DefaultWarehouse;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([
      this.getGenSettings(),
      this.getGlIntegration(),
      this.getDocNum(),
      this.getAccounts(),
      this.getUsers()
    ]);
  }
};
</script>

<style lang="scss" scoped>
.genFont {
  font-size: 1.3em;
  font-weight: 500;
}

.selected-row {
  background-color: #000;
  /* Change this to your desired color */
}

/* Hide number input spinner arrows */
::v-deep input[type="number"]::-webkit-outer-spin-button,
::v-deep input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

::v-deep input[type="number"] {
  -moz-appearance: textfield;
}
</style>

